// External dependencies.
import $ from "jquery";

/**
 * Accordion class.
 *
 * @since 0.10.0
 * @class Accordion
 */
class Accordion {
    /**
     * Creates an instance of Accordion.
     * 
     * @since 0.10.0
     * @memberof Accordion
     */
    constructor() {
        this.accordions = document.querySelectorAll( '.accordion' );
        this.events = this.events.bind( this );
        this.toggleOpen = this.toggleOpen.bind( this );

        this.events();
    }

    /**
     * Listens for events.
     *
     * @since 0.10.0
     * @listens event:show.bs.collapse
     * @listens event:hide.bs.collapse
     * @memberof Accordion
     */
    events() {
        !!this.accordions.length && this.accordions.forEach( elem => {
            $( elem ).on( 'show.bs.collapse hide.bs.collapse', this.toggleOpen );
        } );
    }

    /**
     * Toggles the card-header--open class.
     *
     * @since 0.10.0
     * @param object e
     * @memberof Accordion
     */
    toggleOpen( e ) {
        const cardHeader = e.target.previousElementSibling;

        if ( cardHeader ) {
            cardHeader.classList.toggle( 'card-header--open' );
        }
    }
}

export default Accordion;
